<template>
  <div class="tab_menu" :class="[tabClass,lastCategory]">
    <div v-if="categoryList">
      <swiper-container
        ref="swiper"
        init="false"
        slides-per-view="auto"
        space-between="24"
        free-mode="false"
        @touchend="touchend"
      >
        <swiper-slide v-for="(item, i) in categoryList" :key="item.categoryNo" :class="{ on: currentCategoryNo === item.categoryNo }">
          <a href="#" @click.prevent="changeCategory(item)">{{ item.categoryName }}</a>
        </swiper-slide>
      </swiper-container>
    </div>
    <div v-else />
  </div>

  <div v-show="isWhereType" class="text_right">
    <FormSelectbox :option="WHERE_TYPE_CODE" :value="whereType" @select:option="changeWhereType" />
  </div>
  <BusinessBlogList ref="blogList" :class-type="[type]" />
</template>
<script setup lang="ts">

import { WHERE_TYPE_CODE } from '~/modules/member/mypage/home/config/code'
import type { ICategory } from '~/modules/category/types/model'

const { api, type, categoryList, isWhereType, businessSeq, tabClass } = defineProps<{ api : string, type: string, categoryList: ICategory[], isWhereType: boolean, businessSeq: number, tabClass: string }>()

const currentCategoryNo = ref<number>(0)
const currentCategoryName = ref<string>('')
const whereType = ref<string | null>(isWhereType ? WHERE_TYPE_CODE[0].comCd : null)
const seq = ref<number | null>(businessSeq)
const blogList = ref()

const lastCategory = ref<string>('')

const init = async () => {
  if (categoryList.length > 0) {
    currentCategoryNo.value = categoryList[0].categoryNo
    currentCategoryName.value = categoryList[0].categoryName
    await blogList.value.getBlogList({ categoryNo: currentCategoryNo.value, categoryName: currentCategoryName.value, whereType: whereType.value, api, businessSeq: seq })
  }
}

/**
 * swiper init
 */
const swiper = ref()
onMounted(() => {
  init()
  nextTick(() => {
    initSwiper()
  })
})
const initSwiper = () => {
  // swiper parameters
  const swiperParams = {
    slidesPerView: 'auto',
    breakpoints: {
      0: {
        spaceBetween: 6
      },
      768: {
        spaceBetween: 24
      }
    },
    on: {
      init () {
        // init
      }
    },
    loop: false,
    rewind: false,
    freeMode: false
  }
  // now we need to assign all parameters to Swiper element
  Object.assign(swiper.value, swiperParams)
  // and now initialize it
  swiper.value.initialize()
}

/**
 * 검색 타입 변경
 * @param select
 */
const changeWhereType = (select: string) => {
  whereType.value = select
  blogList.value.getBlogList({ categoryNo: currentCategoryNo.value, categoryName: currentCategoryName.value, whereType: select, api, businessSeq: seq })
}

/**
 * 카테고리 변경
 * @param category
 */
const changeCategory = (category: ICategory) => {
  currentCategoryNo.value = category.categoryNo
  blogList.value.getBlogList({ categoryNo: category.categoryNo, categoryName: category.categoryName, whereType: whereType.value, api, businessSeq: seq })
}

/**
 * 스와이프 슬라이드 변경시 이벤트
 */
const touchend = () => {
  if (swiper.value) {
    lastCategory.value = swiper.value.swiper.isEnd ? 'last' : ''
  }
}

</script>
<style scoped>
@media screen and (max-width: 768px) {
  .tab_menu.last:after {
    display: none;
  }
}
</style>
